import React from "react";

export default function CloseX(props) {
  return <i className={`fas fa-times fa-xs ${props.className}`} />;
}
